<script lang="ts">
	import * as m from '$lib/paraglide/messages.js';

	let { text = '' }: { text?: string } = $props();
	let copied = $state(false);

	async function copy() {
		if (!text) return;
		try {
			await navigator.clipboard.writeText(text);
			copied = true;
			setTimeout(() => (copied = false), 2000);
		} catch {
			// Fallback
			const textarea = document.createElement('textarea');
			textarea.value = text;
			document.body.appendChild(textarea);
			textarea.select();
			document.execCommand('copy');
			document.body.removeChild(textarea);
			copied = true;
			setTimeout(() => (copied = false), 2000);
		}
	}
</script>

<button class="copy-btn inline-flex items-center justify-center font-medium transition-colors px-3 py-1.5 text-sm rounded-lg border border-outline-variant hover:bg-surface-container" onclick={copy} disabled={!text}>
	{#if copied}
		<svg class="copy-btn__icon copy-btn__icon--success" fill="none" stroke="currentColor" viewBox="0 0 24 24">
			<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
		</svg>
		{m.copied()}
	{:else}
		<svg class="copy-btn__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2"
				d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
			/>
		</svg>
		{m.btn_copy()}
	{/if}
</button>

<style>
	@reference "../../../app.css";

	.copy-btn {
		@apply gap-1;
	}
	.copy-btn__icon {
		@apply w-4 h-4;
	}
	.copy-btn__icon--success {
		@apply text-tertiary;
	}
</style>
